import React, { type Context, type ReactNode, createContext } from 'react';
import type SentryServiceType from 'receivable-invoices-js/services/sentry';

export type SentryService = SentryServiceType;

export const SentryContext: Context<SentryService | null> = createContext<SentryService | null>(
  null
);

export function SentryProvider({
  sentry,
  children,
}: {
  sentry: SentryService;
  children: ReactNode;
}): JSX.Element {
  return <SentryContext.Provider value={sentry}>{children}</SentryContext.Provider>;
}
